module.exports = __webpack_public_path__ + "static/img/cert8.a27e309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert8.png
// module id = Wh+B
// module chunks = 52